import { VHeaders } from '@/models/pagedlistmodel';

export function getPreferenceListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('preferences.preferencesGirdHeaders.key') as string,
      align: 'left',
      value: 'key',
      sortable: true,
    },
    {
      text: vm.$parent.$t('preferences.preferencesGirdHeaders.value') as string,
      align: 'left',
      value: 'value',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'preferences.preferencesGirdHeaders.action'
      ) as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
